import { useEffect } from 'react';

/** 탭 제목 — "2 days project", 숫자가 있으면 "(N) 2 days project". 화면을 떠나면 원래 제목으로 */

export const SERVICE_TITLE = '2 days project';

const useTitleBadge = (count = 0, base = SERVICE_TITLE) => {
  useEffect(() => {
    const before = document.title;
    return () => {
      document.title = before;
    };
  }, []);
  useEffect(() => {
    document.title = count > 0 ? `(${count > 99 ? '99+' : count}) ${base}` : base;
  }, [count, base]);
};

export default useTitleBadge;
